import { render } from "./BlockForm.vue?vue&type=template&id=26752cba&ts=true"
import script from "./BlockForm.vue?vue&type=script&lang=ts"
export * from "./BlockForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Contents/Blocks/BlockForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "26752cba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('26752cba', __exports__)) {
    api.reload('26752cba', __exports__)
  }
  
  module.hot.accept("./BlockForm.vue?vue&type=template&id=26752cba&ts=true", () => {
    api.rerender('26752cba', render)
  })

}


export default __exports__